<rl-titulo>Imprimir Evaluación</rl-titulo>

<imprimir-ensayo-externo *ngIf="evaluacionId" [evaluacionId]="evaluacionId"></imprimir-ensayo-externo>
